module.exports = __webpack_public_path__ + "img/profile-game-controller-inactive.4b4a12fa.svg";